import { useEffect, useState } from "react";
import Loader from "../../../../components/Loader.jsx";
import { useResponsive } from "../../../../hooks/useResponsive.js";

export default function PlatformRatingsIframe({ src, iframeTitle = "Ratings" }) {
  const { isMobile } = useResponsive();
  const [iframeLoading, setIframeLoading] = useState(true);

  useEffect(() => {
    setIframeLoading(true);
  }, [src]);

  return (
    <div
      className={`relative w-full overflow-hidden rounded-xl border border-[#E8E8E8] bg-white ${
        isMobile ? "h-[calc(100dvh-200px)] min-h-[320px]" : "h-[calc(100vh-150px)]"
      }`}
    >
      {iframeLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/80">
          <Loader />
        </div>
      )}
      <iframe
        key={src}
        src={src}
        title={iframeTitle}
        frameBorder="0"
        width="100%"
        height="100%"
        className="border-0"
        onLoad={() => setIframeLoading(false)}
      />
    </div>
  );
}
